import { EnumBuilder } from '@mntn-dev/utility-types'
import type { ZodSimplify } from '@mntn-dev/utility-types'

export const [TransactionKinds, TransactionKindSchema, TransactionKindMap] =
  EnumBuilder('payment', 'charge')

export type TransactionKind = ZodSimplify<typeof TransactionKindSchema>
